/** Status value that still needs attention (lookup: Received). */
export const OPEN_STATUS = 0;
const IN_PROGRESS_TIME_LIMIT = typeof __IN_PROGRESS_TIME_LIMIT__ !== 'undefined'
    ? __IN_PROGRESS_TIME_LIMIT__
    : '48 hours';
/**
 * Parse env values like `48`, `48 hours`, or `2 days` into hours.
 * Strips trailing `# ...` comments so `2 # days` is not misread as `2` hours.
 * Defaults to 48 hours when unset/invalid.
 */
export function parseTimeLimitHours(raw, fallback = 48) {
    if (!raw?.trim())
        return fallback;
    const withoutComment = raw.replace(/\s+#.*$/, '').trim();
    const match = withoutComment.match(/^(\d+(?:\.\d+)?)\s*(h|hr|hrs|hour|hours|d|day|days)?$/i);
    if (!match)
        return fallback;
    const amount = Number(match[1]);
    if (!Number.isFinite(amount) || amount < 0)
        return fallback;
    const unit = (match[2] ?? 'hours').toLowerCase();
    if (unit.startsWith('d'))
        return amount * 24;
    return amount;
}
export function getInProgressTimeLimitHours() {
    return parseTimeLimitHours(IN_PROGRESS_TIME_LIMIT, 48);
}
function formatOverdueTimer(overdueMs) {
    const totalSeconds = Math.max(0, Math.floor(overdueMs / 1000));
    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = totalSeconds % 60;
    const parts = [];
    if (days > 0)
        parts.push(days === 1 ? '1 day' : `${days} days`);
    if (hours > 0 || days > 0)
        parts.push(hours === 1 ? '1 hour' : `${hours} hours`);
    parts.push(minutes === 1 ? '1 minute' : `${minutes} minutes`);
    return {
        label: parts.join(' '),
        days,
        hours,
        minutes,
        seconds,
        totalMs: overdueMs,
    };
}
/** Overdue timer past the Open→In Progress limit, or null if not overdue / not Open. */
export function getOpenOverdueTimer(createdIso, status, limitHours = getInProgressTimeLimitHours(), nowMs = Date.now()) {
    if (status !== OPEN_STATUS || !createdIso || limitHours <= 0)
        return null;
    const createdMs = Date.parse(createdIso);
    if (Number.isNaN(createdMs))
        return null;
    const overdueMs = nowMs - createdMs - limitHours * 3600000;
    if (overdueMs <= 0)
        return null;
    return formatOverdueTimer(overdueMs);
}
